module.exports = __webpack_public_path__ + "img/mini-logo.4cfb574b.png";